import modulesMap from 'core/modulesMap';
import Tabs from 'components/tabs/Tabs';
import { staggerItems } from 'core/animations';
import Footer from 'components/footer/Footer';
import InternalRouter from './InternalRouter';
class TabsPage extends InternalRouter {
    static pageName = 'TabsPage';
    getModulesMap() {
        return {
            ...super.getModulesMap(),
            tabs: ['.tabs', Tabs],
            adaptableWrapper: modulesMap.adaptableWrapper,
            footer: ['footer', Footer]
        };
    }
    setTabsHeaderHeight() {
        if (this.refs.pageTabsHeader instanceof HTMLElement) {
            const pageTabsHeaderHeight = this.refs.pageTabsHeader.getBoundingClientRect().height;
            this.el.style.setProperty('--page-tabs-header-height', `${pageTabsHeaderHeight}px`);
        }
    }
    show() {
        staggerItems(this.refs.transversalLinks, { initialDelay: 1000 });
        return super.show(...arguments);
    }
    async internalRouting(pathName, xhr, requestOptions) {
        await super.internalRouting(pathName, xhr, requestOptions);
        this.pageManager.watch();
    }
    resize() {
        super.resize();
        this.setTabsHeaderHeight();
    }
}
export default TabsPage;
